import {
  hondaStorageFileRequestSchema,
  type HondaStorageFileRequest,
} from './hondaStorageFileRequestSchema';

export const importHondaRecallMessageInputSchema = hondaStorageFileRequestSchema;

export type ImportHondaRecallMessageInput = HondaStorageFileRequest;
